import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CheckCircleIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="w-full" data-id="element-92">
      <Helmet data-id="element-93">
        <title data-id="element-94">
          Tentang Kami - PT Jagat Indo Perkasa | Profil Perusahaan Ground
          Handling Terpercaya
        </title>
        <meta name="description" content="PT Jagat Indo Perkasa adalah penyedia layanan ground handling profesional di Indonesia sejak 1977. Dipimpin oleh H. GT. Denny Ramdhani, S.H., kami berkomitmen pada keselamatan, efisiensi, profesionalisme, dan keandalan dalam setiap operasi penerbangan." data-id="element-95" />
        <meta name="keywords" content="tentang PT Jagat Indo Perkasa, profil perusahaan ground handling, H. GT. Denny Ramdhani, sejarah ground handling Indonesia, nilai perusahaan, misi ground handling, visi perusahaan penerbangan" data-id="element-96" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-97" />
        <meta name="robots" content="index, follow" data-id="element-98" />
        <link rel="canonical" href="https://jagatindoperkasa.id/about" data-id="element-99" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-100" />
        <meta property="og:url" content="https://jagatindoperkasa.id/about" data-id="element-101" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-102" />
        <meta property="og:title" content="Tentang Kami - PT Jagat Indo Perkasa | Ground Handling Terpercaya" data-id="element-103" />
        <meta property="og:description" content="Profesionalisme dan dedikasi dalam setiap operasi ground handling. Dipimpin oleh direktur berpengalaman dengan komitmen pada keunggulan operasional sejak 1977." data-id="element-104" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-105" />
        <meta property="og:image:width" content="1200" data-id="element-106" />
        <meta property="og:image:height" content="630" data-id="element-107" />
        <meta property="og:locale" content="id_ID" data-id="element-108" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-109" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/about" data-id="element-110" />
        <meta name="twitter:title" content="Tentang PT Jagat Indo Perkasa - Ground Handling Profesional" data-id="element-111" />
        <meta name="twitter:description" content="Profesionalisme dan dedikasi dalam setiap operasi ground handling sejak 1977. Komitmen pada keselamatan dan keunggulan operasional." data-id="element-112" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-113" />
        {/* Structured Data */}
        <script type="application/ld+json" data-id="element-114">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          '@id': 'https://jagatindoperkasa.id/about#aboutpage',
          url: 'https://jagatindoperkasa.id/about',
          name: 'Tentang PT Jagat Indo Perkasa',
          description: 'Profil dan sejarah PT Jagat Indo Perkasa sebagai penyedia layanan ground handling terpercaya di Indonesia',
          mainEntity: {
            '@type': 'Organization',
            '@id': 'https://jagatindoperkasa.id/#organization'
          }
        })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-115">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-117">Tentang Kami</h1>
          <p className="text-xl text-sky-100" data-id="element-118">
            Profesionalisme dan dedikasi dalam setiap operasi ground handling
          </p>
        </div>
      </section>
      {/* Director's Message */}
      <section className="py-16 bg-white" data-id="element-119">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-121">
            <div className="lg:col-span-1" data-id="element-122">
              <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-8 text-center" data-id="element-123">
                <div className="w-48 h-48 mx-auto rounded-full mb-6 overflow-hidden" data-id="element-124">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7qHA5xTLqzhhJbzjaRyUa8/HGT.png" alt="H. GT. Denny Ramdhani, S.H." className="w-full h-full object-cover" data-id="element-125" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-126">
                  H. GT. Denny Ramdhani, S.H.
                </h3>
                <p className="text-sky-600 font-semibold" data-id="element-127">Director</p>
              </div>
            </div>
            <div className="lg:col-span-2" data-id="element-128">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-129">
                Pesan Direktur
              </h2>
              <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-130">
                <p data-id="element-131">
                  Dengan semangat profesionalisme dan dedikasi, kami hadir untuk
                  memberikan layanan ground handling yang mengutamakan
                  keselamatan, efisiensi, dan ketepatan dalam setiap operasi.
                </p>
                <p data-id="element-132">
                  PT. Jagat Indo Perkasa berkomitmen untuk menjadi mitra
                  terpercaya dalam mendukung kelancaran operasional penerbangan
                  di Indonesia. Kami memahami bahwa setiap detik sangat berharga
                  dalam industri penerbangan, dan kami siap memberikan yang
                  terbaik.
                </p>
                <p data-id="element-133">
                  Melalui tim profesional yang terlatih dan berpengalaman, kami
                  terus berinovasi untuk menciptakan ekosistem penerbangan yang
                  aman, andal, dan efisien. Kepercayaan Anda adalah aset
                  terbesar kami.
                </p>
                <div className="pt-6" data-id="element-134">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-135">
                    H. GT. Denny Ramdhani, S.H.
                  </div>
                  <div className="text-sky-600" data-id="element-136">Director</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-12" data-id="element-137">
            <div className="p-8" data-id="element-138">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xhap8KvBu54aBHmsM3om1z/PT_JAGAT_INDO_PERKASA-2.png" alt="PT Jagat Indo Perkasa Logo" className="w-[300px] h-auto object-contain" data-id="element-139" />
            </div>
          </div>
        </div>
      </section>
      {/* Company Values */}
      <section className="py-16 bg-gray-50" data-id="element-140">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
          <div className="text-center mb-12" data-id="element-142">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-143">
              Nilai-Nilai Perusahaan
            </h2>
            <p className="text-lg text-gray-600" data-id="element-144">
              Fondasi yang membentuk setiap keputusan dan tindakan kami
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-145">
            {[{
            title: 'Keselamatan',
            description: 'Keselamatan adalah prioritas utama dalam setiap aspek operasional kami. Kami menerapkan standar keselamatan internasional yang ketat.'
          }, {
            title: 'Efisiensi',
            description: 'Kami mengoptimalkan setiap proses untuk memastikan operasi yang cepat, tepat waktu, dan efisien tanpa mengorbankan kualitas.'
          }, {
            title: 'Ketepatan',
            description: 'Presisi dalam setiap detail adalah kunci kesuksesan kami. Kami memastikan setiap tugas dilakukan dengan akurasi tinggi.'
          }, {
            title: 'Inovasi',
            description: 'Kami terus berinovasi dengan mengadopsi teknologi terbaru dan praktik terbaik dalam industri ground handling.'
          }, {
            title: 'Keandalan',
            description: 'Sebagai mitra terpercaya, kami berkomitmen untuk memberikan layanan yang konsisten dan dapat diandalkan setiap saat.'
          }, {
            title: 'Profesionalisme',
            description: 'Tim kami terdiri dari profesional terlatih yang berdedikasi untuk memberikan layanan berkualitas tinggi.'
          }].map((value, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm" data-id="element-146">
                <div className="flex items-start space-x-4" data-id="element-147">
                  <CheckCircleIcon className="w-6 h-6 text-sky-600 flex-shrink-0 mt-1" data-id="element-148" />
                  <div data-id="element-149">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-150">
                      {value.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-151">{value.description}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}